var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('v-icon',{staticClass:"loader",attrs:{"name":"spinner","scale":_vm.size,"spin":""}}),(_vm.label)?_c('p',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }